module.exports = __webpack_public_path__ + "images/1bfb2767f850a78c7b0f74976d0731b6.png";